module.exports = __webpack_public_path__ + "static/media/3.783de51f.jpg";